import { Box, Stack } from "@mui/material";
import { InventoryTable } from "./table/inventory/inventoryTable";
import { ObtainableReport } from "./table/detailDrawers/ObtainableReport";
import { usePlan } from "contexts/plan";
import { RefObject, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useTenantTranslation } from "hooks/formatters";
import TableChartIcon from "@mui/icons-material/TableChart";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { GridApiPremium } from "@mui/x-data-grid-premium";

interface Props {
  planId: number;
}

export const InventoryTab = ({ planId }: Props) => {
  const { plan } = usePlan(planId);
  const { t } = useTenantTranslation();
  const apiRef = useGridApiRef();

  const [open, setOpen] = useState(false);

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" sx={{ w: 1, mt: 1 }}>
        <ExportInventoryTable apiRef={apiRef} />
        <LoadingButton
          variant="text"
          color="primary"
          onClick={() => {
            setOpen(true);
          }}
          sx={{ textTransform: "none" }}
          loading={plan.status !== "success"}
          startIcon={<TableChartIcon />}
        >
          {t("seeObtainableReport")}
        </LoadingButton>

        {plan.status === "success" ? (
          <ObtainableReport
            plan={plan.data}
            open={open}
            onClose={() => {
              setOpen(false);
            }}
          />
        ) : null}
      </Stack>
      <Box sx={{ py: 1, minHeight: 0 }}>
        <InventoryTable planId={planId} apiRef={apiRef} />
      </Box>
    </>
  );
};

const ExportInventoryTable = ({
  apiRef,
}: {
  apiRef: RefObject<GridApiPremium | null>;
}) => {
  const { t } = useTenantTranslation();

  const downloadExcel = async () => {
    await apiRef.current?.exportDataAsExcel();
  };

  return (
    <LoadingButton
      variant="text"
      color="primary"
      onClick={() => void downloadExcel()}
      sx={{ textTransform: "none" }}
      loading={!apiRef.current}
      startIcon={<CloudDownloadIcon />}
    >
      {t("downloadExcel")}
    </LoadingButton>
  );
};
